// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.1
//   protoc               v4.23.4
// source: common/feed.proto

/* eslint-disable */
import type { FileAttachment } from "./attachment";
import type { Money } from "./money";
import type { User, UserType } from "./users";

export interface FeedEntity {
  dmsPost?: FeedDmsPost | undefined;
  dmsFeed?: FeedDmsFeed | undefined;
  dmsFeedMember?: FeedDmsFeedMember | undefined;
  reaction?: FeedReaction | undefined;
  user?: FeedUser | undefined;
  chatFeed?: FeedChatFeed | undefined;
  mutedUser?: FeedMutedUser | undefined;
  forumFeed?: FeedForumFeed | undefined;
  forumPost?: FeedForumPost | undefined;
  postReactionCountUpdate?: FeedPostReactionCountUpdate | undefined;
  livestreamFeed?: FeedLivestreamFeed | undefined;
  dmsUnreadBadgeUpdate?: FeedDmsUnreadBadgeUpdate | undefined;
}

export interface SendFeedEntityToUserRequest {
  userId: string;
  feedEntity: FeedEntity | undefined;
  userIds: string[];
}

export interface SendFeedEntityToUserResponse {
  sent: boolean;
}

export interface FeedSyncError {
  message: string;
}

export interface FeedDmsPost {
  /** Entity Base */
  entityType: string;
  entityId: string;
  createdAt: number;
  updatedAt: number;
  Deleted: boolean;
  syncError: FeedSyncError | undefined;
  isSynced: boolean;
  sortKey: string;
  /** Custom Fields */
  feedId: string;
  feedType: string;
  userId: string;
  parentId: string;
  isEdited: boolean;
  title: string;
  content: string;
  richContent: string;
  childrenCount: number;
  /** @deprecated */
  reactionCounts:
    | FeedDmsPost_ReactionCounts
    | undefined;
  /**
   * use files instead
   *
   * @deprecated
   */
  attachments: FeedDmsPost_PostAttachment[];
  gifs: FeedDmsPost_GiphyGif[];
  replyingToPostId: string;
  links: FeedDmsPost_LinkEmbed[];
  isPinned: boolean;
  everyoneMentioned: boolean;
  mentionedUserIds: string[];
  viewCount: number;
  postReactionCounts: PostReactionCount[];
  isPosterAdmin: boolean;
  messageType: FeedDmsPost_MessageType;
  embed?: PostEmbed | undefined;
  user: User | undefined;
  files: FileAttachment[];
  experienceId?: string | undefined;
  poll?: Poll | undefined;
  markdownContent: string;
  replyingToPost?: FeedDmsPost | undefined;
}

export const FeedDmsPost_MessageType = {
  UNKNOWN_TYPE: "UNKNOWN_TYPE",
  REGULAR: "REGULAR",
  SYSTEM: "SYSTEM",
  AUTOMATED: "AUTOMATED",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type FeedDmsPost_MessageType = typeof FeedDmsPost_MessageType[keyof typeof FeedDmsPost_MessageType];

export namespace FeedDmsPost_MessageType {
  export type UNKNOWN_TYPE = typeof FeedDmsPost_MessageType.UNKNOWN_TYPE;
  export type REGULAR = typeof FeedDmsPost_MessageType.REGULAR;
  export type SYSTEM = typeof FeedDmsPost_MessageType.SYSTEM;
  export type AUTOMATED = typeof FeedDmsPost_MessageType.AUTOMATED;
  export type UNRECOGNIZED = typeof FeedDmsPost_MessageType.UNRECOGNIZED;
}

export interface FeedDmsPost_ImageAttachment {
  type: string;
  fileUrl: string;
  fileCategory: string;
  fileName: string;
  /** @deprecated */
  fileSize: number;
  blurDataUrl: string;
  aspectRatio: number;
  byteSize: number;
}

export interface FeedDmsPost_DocumentAttachment {
  type: string;
  fileUrl: string;
  fileCategory: string;
  fileName: string;
  /** @deprecated */
  fileSize: number;
  byteSize: number;
}

export interface FeedDmsPost_VideoAttachment {
  type: string;
  fileUrl: string;
  fileCategory: string;
  fileName: string;
  /** @deprecated */
  fileSize: number;
  blurDataUrl: string;
  aspectRatio: number;
  thumbnailUrl: string;
  height: number;
  width: number;
  byteSize: number;
}

export interface FeedDmsPost_GiphyGif {
  title: string;
  url: string;
  originalUrl: string;
  previewUrl: string;
  width: number;
  height: number;
  slug: string;
}

export interface FeedDmsPost_PostAttachment {
  image?: FeedDmsPost_ImageAttachment | undefined;
  document?: FeedDmsPost_DocumentAttachment | undefined;
  video?: FeedDmsPost_VideoAttachment | undefined;
}

export interface FeedDmsPost_ReactionCount {
  score: number;
  count: number;
}

export interface FeedDmsPost_ReactionCounts {
  counts: { [key: string]: FeedDmsPost_ReactionCount };
}

export interface FeedDmsPost_ReactionCounts_CountsEntry {
  key: string;
  value: FeedDmsPost_ReactionCount | undefined;
}

export interface FeedDmsPost_LinkEmbed {
  url: string;
  title: string;
  description: string;
  image: string;
  favicon: string;
  processing: boolean;
}

export interface FeedDmsFeed {
  /** Entity Base */
  entityType: string;
  entityId: string;
  createdAt: number;
  updatedAt: number;
  Deleted: boolean;
  syncError: FeedSyncError | undefined;
  isSynced: boolean;
  /** Feed Fields */
  rootPostCount: number;
  postCount: number;
  collectionIdentifier: string;
  feedType: string;
  sortKey: string;
  /** Custom Fields */
  customName: string;
}

export interface FeedChatFeed {
  /** Entity Base */
  entityType: string;
  entityId: string;
  createdAt: number;
  updatedAt: number;
  Deleted: boolean;
  syncError: FeedSyncError | undefined;
  isSynced: boolean;
  /** Feed Fields */
  rootPostCount: number;
  postCount: number;
  collectionIdentifier: string;
  feedType: string;
  sortKey: string;
  /** Custom Fields */
  experienceId: string;
  banUrls: boolean;
  whoCanReact: FeedChatFeed_MemberPermissionType;
  whoCanPost: FeedChatFeed_MemberPermissionType;
  requiredProductIdsToWrite: string[];
  banMedia: boolean;
  userPostsCooldownSeconds: number;
  banUnverifiedUsers: boolean;
}

export const FeedChatFeed_MemberPermissionType = {
  UNKNOWN: "UNKNOWN",
  NONE: "NONE",
  EVERYONE: "EVERYONE",
  MEMBERS: "MEMBERS",
  ADMINS: "ADMINS",
  PRODUCT_OWNERS: "PRODUCT_OWNERS",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type FeedChatFeed_MemberPermissionType =
  typeof FeedChatFeed_MemberPermissionType[keyof typeof FeedChatFeed_MemberPermissionType];

export namespace FeedChatFeed_MemberPermissionType {
  export type UNKNOWN = typeof FeedChatFeed_MemberPermissionType.UNKNOWN;
  export type NONE = typeof FeedChatFeed_MemberPermissionType.NONE;
  export type EVERYONE = typeof FeedChatFeed_MemberPermissionType.EVERYONE;
  export type MEMBERS = typeof FeedChatFeed_MemberPermissionType.MEMBERS;
  export type ADMINS = typeof FeedChatFeed_MemberPermissionType.ADMINS;
  export type PRODUCT_OWNERS = typeof FeedChatFeed_MemberPermissionType.PRODUCT_OWNERS;
  export type UNRECOGNIZED = typeof FeedChatFeed_MemberPermissionType.UNRECOGNIZED;
}

export interface FeedLivestreamFeed {
  /** Entity Base */
  entityType: string;
  entityId: string;
  createdAt: number;
  updatedAt: number;
  Deleted: boolean;
  syncError: FeedSyncError | undefined;
  isSynced: boolean;
  /** Feed Fields */
  rootPostCount: number;
  postCount: number;
  collectionIdentifier: string;
  feedType: string;
  sortKey: string;
  /**
   * Custom Fields
   *
   * @deprecated
   */
  experienceId: string;
  banUrls: boolean;
  banMedia: boolean;
  banUnverifiedUsers: boolean;
  bannedWords: string[];
  userPostsCooldownSeconds: number;
  whoCanReact: FeedLivestreamFeed_MemberPermissionType;
  whoCanPost: FeedLivestreamFeed_MemberPermissionType;
  recordingUrl?: string | undefined;
  thumbnailUrl?: string | undefined;
  experienceIds: string[];
  reactionsEnabled: boolean;
  /** Livekit fields */
  title: string;
  description: string;
  emptyTimeout: number;
  maxParticipants: number;
  scheduledAt: number;
  startedAt: number;
  endedAt: number;
  metadata: { [key: string]: string };
  hostId: string;
  recording?: FileAttachment | undefined;
}

export const FeedLivestreamFeed_MemberPermissionType = {
  UNKNOWN: "UNKNOWN",
  NONE: "NONE",
  EVERYONE: "EVERYONE",
  ADMINS: "ADMINS",
  PRODUCT_OWNERS: "PRODUCT_OWNERS",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type FeedLivestreamFeed_MemberPermissionType =
  typeof FeedLivestreamFeed_MemberPermissionType[keyof typeof FeedLivestreamFeed_MemberPermissionType];

export namespace FeedLivestreamFeed_MemberPermissionType {
  export type UNKNOWN = typeof FeedLivestreamFeed_MemberPermissionType.UNKNOWN;
  export type NONE = typeof FeedLivestreamFeed_MemberPermissionType.NONE;
  export type EVERYONE = typeof FeedLivestreamFeed_MemberPermissionType.EVERYONE;
  export type ADMINS = typeof FeedLivestreamFeed_MemberPermissionType.ADMINS;
  export type PRODUCT_OWNERS = typeof FeedLivestreamFeed_MemberPermissionType.PRODUCT_OWNERS;
  export type UNRECOGNIZED = typeof FeedLivestreamFeed_MemberPermissionType.UNRECOGNIZED;
}

export interface FeedLivestreamFeed_MetadataEntry {
  key: string;
  value: string;
}

export interface FeedMutedUser {
  /** Entity Base */
  entityType: string;
  entityId: string;
  createdAt: number;
  updatedAt: number;
  Deleted: boolean;
  syncError: FeedSyncError | undefined;
  isSynced: boolean;
  /** Custom Fields */
  userId: string;
  feedId: string;
  feedType: string;
  mutedUntil: number;
}

export interface FeedDmsFeedMember {
  /** Entity Base */
  entityType: string;
  entityId: string;
  createdAt: number;
  updatedAt: number;
  Deleted: boolean;
  syncError: FeedSyncError | undefined;
  isSynced: boolean;
  /** Feed Member Fields */
  feedId: string;
  userId: string;
  companyId: string;
  feedType: string;
  sortKey: string;
  /** Custom Fields */
  status: FeedDmsFeedMember_DmsFeedMemberStatus;
  lastViewedAt: number;
  lastTypedAt: number;
  notificationPreference: FeedDmsFeedMember_NotificationPreference;
  pinnedPosition?: number | undefined;
}

export const FeedDmsFeedMember_DmsFeedMemberStatus = {
  UNKNOWN_STATUS: "UNKNOWN_STATUS",
  REQUESTED: "REQUESTED",
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
  CLOSED: "CLOSED",
  ARCHIVED: "ARCHIVED",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type FeedDmsFeedMember_DmsFeedMemberStatus =
  typeof FeedDmsFeedMember_DmsFeedMemberStatus[keyof typeof FeedDmsFeedMember_DmsFeedMemberStatus];

export namespace FeedDmsFeedMember_DmsFeedMemberStatus {
  export type UNKNOWN_STATUS = typeof FeedDmsFeedMember_DmsFeedMemberStatus.UNKNOWN_STATUS;
  export type REQUESTED = typeof FeedDmsFeedMember_DmsFeedMemberStatus.REQUESTED;
  export type ACCEPTED = typeof FeedDmsFeedMember_DmsFeedMemberStatus.ACCEPTED;
  export type REJECTED = typeof FeedDmsFeedMember_DmsFeedMemberStatus.REJECTED;
  export type CLOSED = typeof FeedDmsFeedMember_DmsFeedMemberStatus.CLOSED;
  export type ARCHIVED = typeof FeedDmsFeedMember_DmsFeedMemberStatus.ARCHIVED;
  export type UNRECOGNIZED = typeof FeedDmsFeedMember_DmsFeedMemberStatus.UNRECOGNIZED;
}

export const FeedDmsFeedMember_NotificationPreference = {
  UNKNOWN_PREFERENCE: "UNKNOWN_PREFERENCE",
  ALL: "ALL",
  MENTIONS: "MENTIONS",
  NONE: "NONE",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type FeedDmsFeedMember_NotificationPreference =
  typeof FeedDmsFeedMember_NotificationPreference[keyof typeof FeedDmsFeedMember_NotificationPreference];

export namespace FeedDmsFeedMember_NotificationPreference {
  export type UNKNOWN_PREFERENCE = typeof FeedDmsFeedMember_NotificationPreference.UNKNOWN_PREFERENCE;
  export type ALL = typeof FeedDmsFeedMember_NotificationPreference.ALL;
  export type MENTIONS = typeof FeedDmsFeedMember_NotificationPreference.MENTIONS;
  export type NONE = typeof FeedDmsFeedMember_NotificationPreference.NONE;
  export type UNRECOGNIZED = typeof FeedDmsFeedMember_NotificationPreference.UNRECOGNIZED;
}

export interface FeedReaction {
  /** Entity Base */
  entityType: string;
  entityId: string;
  createdAt: number;
  updatedAt: number;
  Deleted: boolean;
  syncError: FeedSyncError | undefined;
  isSynced: boolean;
  /** Custom Fields */
  postId: string;
  postType: string;
  userId: string;
  feedId: string;
  feedType: string;
  reactionType: FeedReaction_ReactionType;
  value: string;
  score: number;
}

export const FeedReaction_ReactionType = {
  UNKNOWN: "UNKNOWN",
  LIKE: "LIKE",
  EMOJI: "EMOJI",
  VIEW: "VIEW",
  VOTE: "VOTE",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type FeedReaction_ReactionType = typeof FeedReaction_ReactionType[keyof typeof FeedReaction_ReactionType];

export namespace FeedReaction_ReactionType {
  export type UNKNOWN = typeof FeedReaction_ReactionType.UNKNOWN;
  export type LIKE = typeof FeedReaction_ReactionType.LIKE;
  export type EMOJI = typeof FeedReaction_ReactionType.EMOJI;
  export type VIEW = typeof FeedReaction_ReactionType.VIEW;
  export type VOTE = typeof FeedReaction_ReactionType.VOTE;
  export type UNRECOGNIZED = typeof FeedReaction_ReactionType.UNRECOGNIZED;
}

export interface FeedUser {
  /** Entity Base */
  entityType: string;
  entityId: string;
  createdAt: number;
  updatedAt: number;
  Deleted: boolean;
  syncError: FeedSyncError | undefined;
  isSynced: boolean;
  /** Custom Fields */
  name: string;
  profilePic: string;
  username: string;
  profilePic32: string;
  profilePic64: string;
  profilePic128: string;
  userType: UserType;
}

export interface FeedForumFeed {
  /** Entity Base */
  entityId: string;
  createdAt: number;
  updatedAt: number;
  isDeleted: boolean;
  /** Feed Fields */
  rootPostCount: number;
  postCount: number;
  collectionIdentifier: string;
  feedType: string;
  sortKey: string;
  /** Custom Fields */
  bannerImage: FileAttachment | undefined;
  whoCanPost: FeedForumFeed_MemberPermissionType;
  whoCanComment: FeedForumFeed_MemberPermissionType;
  layoutType: FeedForumFeed_LayoutType;
  discordWebhookUrl: string;
  telegramChannelId: string;
  emailNotificationPreference: FeedForumFeed_EmailNotificationPreferenceType;
}

export const FeedForumFeed_MemberPermissionType = {
  UNKNOWN_PERMISSION: "UNKNOWN_PERMISSION",
  EVERYONE: "EVERYONE",
  ADMINS: "ADMINS",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type FeedForumFeed_MemberPermissionType =
  typeof FeedForumFeed_MemberPermissionType[keyof typeof FeedForumFeed_MemberPermissionType];

export namespace FeedForumFeed_MemberPermissionType {
  export type UNKNOWN_PERMISSION = typeof FeedForumFeed_MemberPermissionType.UNKNOWN_PERMISSION;
  export type EVERYONE = typeof FeedForumFeed_MemberPermissionType.EVERYONE;
  export type ADMINS = typeof FeedForumFeed_MemberPermissionType.ADMINS;
  export type UNRECOGNIZED = typeof FeedForumFeed_MemberPermissionType.UNRECOGNIZED;
}

export const FeedForumFeed_LayoutType = {
  UNKNOWN_LAYOUT: "UNKNOWN_LAYOUT",
  FEED: "FEED",
  BLOG: "BLOG",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type FeedForumFeed_LayoutType = typeof FeedForumFeed_LayoutType[keyof typeof FeedForumFeed_LayoutType];

export namespace FeedForumFeed_LayoutType {
  export type UNKNOWN_LAYOUT = typeof FeedForumFeed_LayoutType.UNKNOWN_LAYOUT;
  export type FEED = typeof FeedForumFeed_LayoutType.FEED;
  export type BLOG = typeof FeedForumFeed_LayoutType.BLOG;
  export type UNRECOGNIZED = typeof FeedForumFeed_LayoutType.UNRECOGNIZED;
}

export const FeedForumFeed_EmailNotificationPreferenceType = {
  UNKNOWN_PREFERENCE: "UNKNOWN_PREFERENCE",
  ALL_ADMIN_POSTS: "ALL_ADMIN_POSTS",
  ONLY_WEEKLY_SUMMARY: "ONLY_WEEKLY_SUMMARY",
  NONE: "NONE",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type FeedForumFeed_EmailNotificationPreferenceType =
  typeof FeedForumFeed_EmailNotificationPreferenceType[keyof typeof FeedForumFeed_EmailNotificationPreferenceType];

export namespace FeedForumFeed_EmailNotificationPreferenceType {
  export type UNKNOWN_PREFERENCE = typeof FeedForumFeed_EmailNotificationPreferenceType.UNKNOWN_PREFERENCE;
  export type ALL_ADMIN_POSTS = typeof FeedForumFeed_EmailNotificationPreferenceType.ALL_ADMIN_POSTS;
  export type ONLY_WEEKLY_SUMMARY = typeof FeedForumFeed_EmailNotificationPreferenceType.ONLY_WEEKLY_SUMMARY;
  export type NONE = typeof FeedForumFeed_EmailNotificationPreferenceType.NONE;
  export type UNRECOGNIZED = typeof FeedForumFeed_EmailNotificationPreferenceType.UNRECOGNIZED;
}

export interface MuxAsset {
  assetId?: string | undefined;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  duration?: string | undefined;
  finishedUploadingAt?: string | undefined;
  id: string;
  playbackId?: string | undefined;
  resourceId?: string | undefined;
  resourceType?: string | undefined;
  signedPlaybackId?: string | undefined;
  status: MuxAsset_MuxAssetStatus;
  signedVideoPlaybackToken?: string | undefined;
  signedStoryboardPlaybackToken?: string | undefined;
  signedThumbnailPlaybackToken?: string | undefined;
}

export const MuxAsset_MuxAssetStatus = {
  UNKNOWN: "UNKNOWN",
  UPLOADING: "UPLOADING",
  CREATED: "CREATED",
  READY: "READY",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type MuxAsset_MuxAssetStatus = typeof MuxAsset_MuxAssetStatus[keyof typeof MuxAsset_MuxAssetStatus];

export namespace MuxAsset_MuxAssetStatus {
  export type UNKNOWN = typeof MuxAsset_MuxAssetStatus.UNKNOWN;
  export type UPLOADING = typeof MuxAsset_MuxAssetStatus.UPLOADING;
  export type CREATED = typeof MuxAsset_MuxAssetStatus.CREATED;
  export type READY = typeof MuxAsset_MuxAssetStatus.READY;
  export type UNRECOGNIZED = typeof MuxAsset_MuxAssetStatus.UNRECOGNIZED;
}

export interface Poll {
  options: Poll_PollOption[];
}

export interface Poll_PollOption {
  id: string;
  text: string;
}

export interface PostReactionCount {
  reactionType: PostReactionCount_ReactionType;
  value: string;
  totalScore: number;
  userCount: number;
}

export const PostReactionCount_ReactionType = {
  UNKNOWN: "UNKNOWN",
  LIKE: "LIKE",
  EMOJI: "EMOJI",
  VIEW: "VIEW",
  VOTE: "VOTE",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type PostReactionCount_ReactionType =
  typeof PostReactionCount_ReactionType[keyof typeof PostReactionCount_ReactionType];

export namespace PostReactionCount_ReactionType {
  export type UNKNOWN = typeof PostReactionCount_ReactionType.UNKNOWN;
  export type LIKE = typeof PostReactionCount_ReactionType.LIKE;
  export type EMOJI = typeof PostReactionCount_ReactionType.EMOJI;
  export type VIEW = typeof PostReactionCount_ReactionType.VIEW;
  export type VOTE = typeof PostReactionCount_ReactionType.VOTE;
  export type UNRECOGNIZED = typeof PostReactionCount_ReactionType.UNRECOGNIZED;
}

export interface FeedPostReactionCountUpdate {
  postId: string;
  postType: string;
  feedId: string;
  feedType: string;
  /**
   * Contains a bitmask of the fields that were updated.
   * Only apply the fields that were updated.
   * Eg if this contains the number 3 (0b00000011), then the view count and post reaction counts were updated.
   * If this contains the number 1 (0b00000001), then only the view count was updated.
   * If this contains the number 2 (0b00000010), then only the post reaction counts were updated.
   * This is needed because "optional repeated" fields are not supported in the protobuf spec.
   */
  updatedFieldsBitmask: number;
  /** Position zero in the bitmask (0b00000001) is the view count */
  viewCount?:
    | number
    | undefined;
  /** Position one in the bitmask (0b00000010) is the post reaction counts */
  postReactionCounts: PostReactionCount[];
  /**
   * Position two in the bitmask (0b00000100) is the single post reaction count
   * This may be sent by the backend to indicate that a single post reaction count was updated. The frontend should keep all other post reaction counts the same.
   * Only the score and user_count fields may be updated by the backend, the rest indicate which reaction was updated
   */
  singleReactionCountUpdate?:
    | PostReactionCount
    | undefined;
  /** Position three in the bitmask (0b00001000) is the comment count */
  commentCount?: number | undefined;
}

export interface FeedForumPost {
  /** Entity Base */
  entityId: string;
  createdAt: number;
  updatedAt: number;
  isDeleted: boolean;
  sortKey: string;
  /** Custom Fields */
  feedId: string;
  userId: string;
  parentId?: string | undefined;
  isEdited: boolean;
  title?: string | undefined;
  content: string;
  richContent: string;
  childrenCount: number;
  /**
   * Deprecated in favor of post_reaction_counts
   *
   * @deprecated
   */
  reactionCounts: FeedForumPost_ReactionCounts | undefined;
  attachments: FileAttachment[];
  gifs: FeedForumPost_GiphyGif[];
  links: FeedForumPost_LinkEmbed[];
  isPinned: boolean;
  mentionedUserIds: string[];
  lineItem?: FeedForumPost_LineItem | undefined;
  muxAssets: MuxAsset[];
  poll?: Poll | undefined;
  isPosterAdmin: boolean;
  postReactionCounts: PostReactionCount[];
  forumPostType: FeedForumPost_ForumPostType;
  embed?: PostEmbed | undefined;
  user: User | undefined;
  commentCount: number;
  viewCount: number;
  experienceId?: string | undefined;
  markdownContent: string;
}

export const FeedForumPost_ForumPostType = {
  UNKNOWN_TYPE: "UNKNOWN_TYPE",
  REGULAR: "REGULAR",
  AUTOMATED: "AUTOMATED",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type FeedForumPost_ForumPostType = typeof FeedForumPost_ForumPostType[keyof typeof FeedForumPost_ForumPostType];

export namespace FeedForumPost_ForumPostType {
  export type UNKNOWN_TYPE = typeof FeedForumPost_ForumPostType.UNKNOWN_TYPE;
  export type REGULAR = typeof FeedForumPost_ForumPostType.REGULAR;
  export type AUTOMATED = typeof FeedForumPost_ForumPostType.AUTOMATED;
  export type UNRECOGNIZED = typeof FeedForumPost_ForumPostType.UNRECOGNIZED;
}

export interface FeedForumPost_GiphyGif {
  title: string;
  url: string;
  originalUrl: string;
  previewUrl: string;
  width: number;
  height: number;
  slug: string;
}

export interface FeedForumPost_ReactionCount {
  score: number;
  count: number;
}

export interface FeedForumPost_ReactionCounts {
  counts: { [key: string]: FeedForumPost_ReactionCount };
}

export interface FeedForumPost_ReactionCounts_CountsEntry {
  key: string;
  value: FeedForumPost_ReactionCount | undefined;
}

export interface FeedForumPost_LinkEmbed {
  url: string;
  title: string;
  description: string;
  image: string;
  favicon: string;
  processing: boolean;
}

export interface FeedForumPost_LineItem {
  id: string;
  title: string;
  amount: Money | undefined;
  redirectUrl: string;
}

export interface PostEmbed {
  richEmbeds?: RichEmbedContainer | undefined;
}

export interface RichEmbedContainer {
  embeds: RichEmbed[];
}

/** close enough to mirror a discord style rich embed. https://discord.com/developers/docs/resources/message#embed-object */
export interface RichEmbed {
  color?: number | undefined;
  title?: string | undefined;
  url?: string | undefined;
  description?: string | undefined;
  timestamp?: string | undefined;
  thumbnail?: FileAttachment | undefined;
  image?: FileAttachment | undefined;
  footer?: RichEmbed_Footer | undefined;
  fields: RichEmbed_Field[];
}

export interface RichEmbed_Field {
  name: string;
  value: string;
  inline: boolean;
}

export interface RichEmbed_Footer {
  text: string;
  icon?: FileAttachment | undefined;
}

export interface FeedDmsUnreadBadgeUpdate {
  count: number;
  feedId: string;
  lastViewedAt: string | undefined;
}

export interface FeedService {
  /** @deprecated */
  SendFeedEntityToUser(request: SendFeedEntityToUserRequest): Promise<SendFeedEntityToUserResponse>;
}
